import schema from './schema.json';

export default {
  ...schema,

  migrate(data, fromVersion) {
    if (!fromVersion || fromVersion < 1) {
      if (data.offices) {
        data.offices = data.offices.map((office, index) => ({
          id: office.id || String(index + 1),
          ...office
        }));
      }
      return { ...schema.default, ...data };
    }
    return data;
  }
};
